import { render } from "./Breadcrumb.vue?vue&type=template&id=062c3d0b"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\david\\Documents\\Dada\\Omnichannel-Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__